import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { $mapLoaded } from '../../../models/mapModel/index.js';
import {
  $d11Lines,
  $d11Switches,
  $isPreset,
} from '../../../models/rbpLiteModel/index.js';
import { changeLayerVisibility } from '../../../utils/mapbox-utils.js';
import { $gradientBuckets } from '../../../models/gradientModel/index.js';
import { formDynamicBuckets } from '../../../utils/hexagon-utils.js';

function LiteTrafficJams() {
  const mapLoaded = useUnit($mapLoaded);
  const d11Switches = useUnit($d11Switches);
  const isPreset = useUnit($isPreset);
  const d11Lines = useUnit($d11Lines);
  const { buckets, colors } = useUnit($gradientBuckets);

  const createLayer = (update) => {
    const tjData = {
      type: 'FeatureCollection',
      features: d11Lines,
    };

    const gradientProp = formDynamicBuckets(buckets, colors);

    if (update) {
      window.map.getSource('lite_tj_source').setData(tjData);
      window.map.setPaintProperty('lite_tj_layer', 'line-color', gradientProp);
    } else {
      if (!window.map.getSource('lite_tj_source')) {
        window.map.addSource('lite_tj_source', {
          type: 'geojson',
          data: tjData,
        });
      }

      if (!window.map.getLayer('lite_tj_layer')) {
        window.map.addLayer({
          id: 'lite_tj_layer',
          type: 'line',
          source: 'lite_tj_source',
          paint: {
            'line-color': gradientProp,
            'line-width': 4,
          },
        });
      }

      changeLayerVisibility('lite_tj_layer', false);
    }
  };

  useEffect(() => {
    if (mapLoaded && d11Lines.length > 0) {
      if (window.map.getLayer('lite_tj_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, d11Lines, buckets]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('lite_tj_layer')) {
      if (isPreset) {
        if (d11Switches.traffic_jams) {
          changeLayerVisibility('lite_tj_layer', true);
          setTimeout(() => {
            window.map.moveLayer('lite_tj_layer', 'lite_stops_bg_layer');
            window.map.moveLayer('lite_tj_layer', 'lite_parking_bg_layer');
          }, 500);
        } else {
          changeLayerVisibility('lite_tj_layer', false);
        }
      } else {
        changeLayerVisibility('lite_tj_layer', false);
      }
    }
  }, [mapLoaded, isPreset, d11Switches]);

  return null;
}

export default LiteTrafficJams;
